export * from './my-quotes.interface';
